(function() {
    document.addEventListener('DOMContentLoaded', (event) => {
        if ( location.pathname === '/pages/favoritos' ) {   
            const arrayHandles = localStorage.getItem('favourite-acumulative').split(',')
            console.log(arrayHandles)
            
            arrayHandles.forEach( handle => {
                if ( handle != '' && handle != 'test' ) createProducts( handle )
            })
            
            window.dispatchEvent( new Event('initWishlist') )
        }

        if ( document.querySelector('.wishlistIcon') ) {
            window.dispatchEvent( new Event('initWishlist') )
        }
    })
    
    window.addEventListener('initWishlist', (evt) => {
        console.log('sad')
        initWishlistFunction()
    })

    function createProducts( handle ) {
        $.getJSON(`/products/${handle}.js`, data => {
          console.log(data)
  
        const html = `<div
              class="grid__item grid-product small--one-half medium-up--one-fifth aos-init aos-animate"
              data-aos="row-of-"
              data-product-handle="${data.title}"
              data-slick-index="0"
              aria-hidden="false"
              style="width: 361px;"
              tabindex="-1"
              role="option"
          >
              <div class="grid-product__content">
                  <a href="${data.url}" class="grid-product__link grid-product__link--disabled" tabindex="0">
                      <div class="grid-product__image-mask">
                          <div class="image-wrap" style="height: 0; padding-bottom: 108.984375%;">
                              <img
                                  class="grid-product__image lazyautosizes lazyloaded"
                                  src="${data.featured_image}"
                              />
                              <noscript>
                                  <img class="grid-product__image lazyloaded" src="${data.featured_image}" alt="" />
                              </noscript>
                          </div>
                      </div>
                  </a>
  
                  <div class="grid-product__meta">
                      <a href="${data.url}" tabindex="0">
                          <div class="grid-product__title grid-product__title--body">${data.title}</div>
                      </a>
                      <div class="grid-product__wrap-price">
                          <div class="grid-product__price">
                              <span class="visually-hidden">Precio habitual</span>
                              <span class="grid-product__price--original">${new Intl.NumberFormat("de-DE", {style: "currency", currency: "USD"}).format(data.price/100)}</span>
                          </div>
                          <div id="wishlistIcon--${data.handle}" data-product-title="${data.title}" data-product-handle="${data.handle}" class="wishlistIcon--container">
                              <button class="wishlistIcon" data-product-title="${data.title}" data-product-handle="${data.handle}" tabindex="0">
                                  <img class="empty-icon" id="wishlistIconNoFilled--${data.handle}" src="https://cdn.shopify.com/s/files/1/0498/3350/9024/files/wishlist.svg?v=1614177525" />
                                  <img style="display: none;" id="wishlistIconFilled--${data.handle}" class="full-icon" src="https://cdn.shopify.com/s/files/1/0498/3350/9024/files/wishlist-r.svg?v=1614177388" />
                              </button>
                          </div>
                      </div>
                  </div>
  
                  <div class="wishlistCardButton">
                      <a href="${data.url}">VISITAR</a>
                  </div>
              </div>
          </div>`
          
  
            $('#ProductsContainer').append(html);
          
        })
          
    }
    
    function initWishlistFunction() {
        const FULL_ICON_SRC  = 'https://cdn.shopify.com/s/files/1/0498/3350/9024/files/wishlist-r.svg?v=1614177388'
        const EMPTY_ICON_SRC = 'https://cdn.shopify.com/s/files/1/0498/3350/9024/files/wishlist.svg?v=1614177525'

        $(document).on('mouseenter', '.empty-icon', function(e){
            e.target.setAttribute('src', FULL_ICON_SRC)
        })

        $(document).on('mouseout', '.empty-icon', function(e){
            e.target.setAttribute('src', EMPTY_ICON_SRC)
        })

        function showWishIconFilled( handle ){
            //hides the desired unfilled icon and shows the other one which is filled for 'selected' product
            [...document.querySelectorAll(`#wishlistIconNoFilled--${handle}`)].forEach(function(elem){
              $(elem).fadeOut(function(){
        
                [...document.querySelectorAll(`#wishlistIconFilled--${handle}`)].forEach(function(element){
                  $(element).fadeIn();
                })
        
              });
            })
        }
        
          function showWishIconNotFilled( handle ){
            //hides the desired filled icon and shows the other one which is unfilled for 'selected' product
            [...document.querySelectorAll(`#wishlistIconFilled--${handle}`)].forEach(function(elem){
              $(elem).fadeOut(function(){
        
                [...document.querySelectorAll(`#wishlistIconNoFilled--${handle}`)].forEach(function(element){
                  $(element).fadeIn();
                })
        
              });
            })
        }
        
        function checkFavourites() {
            console.log('checking favorites')
            // checks on the localStorage if any product is added to favourite, and if it is, auto fill the heart for 'favourite' product.
            if ( window.location.pathname.includes('/collections/') || 
            location.href.includes('/pages/tienda') ) {
              if( !localStorage.getItem('favourite-acumulative') ) {
                localStorage.setItem('favourite-acumulative', 'test')
              } else {
                let favCheck = localStorage.getItem('favourite-acumulative').split(',')
                favCheck.forEach( handle => { if ( handle != '' ) { showWishIconFilled( handle ) }})
              }
            }
            //same here but on the favourite page with an 1.5 second delay 'cause on that page is acting another JS code which is a bit slow to process.
            if( location.pathname.includes('/pages/favoritos') ){
              setTimeout(function(){
                let favCheck = localStorage.getItem('favourite-acumulative').split(',');
                favCheck.forEach( handle => { if ( handle != '' ) { showWishIconFilled( handle ) }})
              }, 1500)
            }
        }
        
        
        function showAlert(){
            // this makes the appear and disappear effect of the alert box.
            $('#alert').fadeIn('slow', () => {
                setTimeout(() => { $('#alert').fadeOut() }, 5000)
            })
        }
        
        // on every page loaded execute the check of favourites
        checkFavourites()

        window.addEventListener('checkFavorites', (evt) => {
            checkFavourites()
        })

        $(document).on('click', '.wishlistIcon', function(e){
            e.preventDefault();
            //console.log(e.target)
        
            // because the e.target could be 2 different elements, here is a condition for both of them.
            let favTitle
            if ( e.target.tagName.toLowerCase() === 'button' ) {
                favTitle = e.target.getAttribute('data-product-title');
                favHandle = e.target.getAttribute('data-product-handle');
            } else {
                favTitle = e.target.parentElement.getAttribute('data-product-title');
                favHandle = e.target.parentElement.getAttribute('data-product-handle');
            }
        
            const baseArray = [];
        
            // set blank array if item doesn't exist (this means that person entered for the first time to a product page after code was deployed.)
            if( localStorage.getItem('favourite-acumulative') == null || localStorage.getItem('favourite-acumulative') == undefined ){
              localStorage.setItem('favourite-acumulative', baseArray)
            }
        
            // here starts the piece of code if it already exists or not.
        
            $('#alert').empty();
        
        
            let lastFavArrayCheckExist = localStorage.getItem('favourite-acumulative').split(',');
            //console.log(lastFavArrayCheckExist);
        
            let checkArrayExist = lastFavArrayCheckExist.filter( elem => elem == favHandle )
            //console.log(checkArrayExist)
        
            if(checkArrayExist != ''){
              //here product already exists and it's deleted from favourites
              showWishIconNotFilled(favHandle);
        
              $('#alert').html(`<strong>Se quitó un producto de favoritos: </strong><br><span>'${favTitle}'</span>`)
        
              showAlert();
        
              let whereToDelete = lastFavArrayCheckExist.indexOf(favHandle);
        
              if ( whereToDelete > -1 ) {
                lastFavArrayCheckExist.splice(whereToDelete, 1)
              }
        
              localStorage.setItem('favourite-acumulative', lastFavArrayCheckExist)
        
              if( location.pathname.includes('/pages/favoritos') ) window.location.reload()
        
            } else {
              // here product is added to favourites
              showWishIconFilled(favHandle)
        
              $('#alert').html(`<strong>Se añadió un producto a favoritos: </strong><br><span>'${favTitle}'</span>`)
              lastFavArrayCheckExist.push(favHandle)
        
              localStorage.setItem('favourite-acumulative', lastFavArrayCheckExist)
        
              showAlert();
        
            }
        })
    }
})()